import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'indication',
    standalone: true,
    imports: [ 
        CommonModule,
        TranslateModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './indication.component.html',
    styleUrl: './indication.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class IndicationComponent {
    public intructions: InputSignal<string> = input.required<string>();
    public label: InputSignal<string> = input<string>('A continuación')
    public timeRemaining: InputSignal<number> = input<number>(undefined);
    public isSuccess: InputSignal<boolean> = input<boolean>(false);
    public isEnd: InputSignal<boolean> = input<boolean>(false);
    public nextItem: InputSignal<string> = input<string>(undefined);
    public progress: InputSignal<number> = input<number>(0);
    public sign: InputSignal<any> = input.required<any>();

    public getMappedSign = computed(() => {
        const sign: any = this.sign() as any;
        switch(sign){
            case 'turn_right': return 'turn-right';
            case 'turn_left': return 'turn-left';
            case 'turn_slight_right': return 'turn-right';
            case 'turn_slight_left': return 'turn-left';
            case 'u_turn_left': return 'u-turn-left';
            default: return sign;
        }
    })

}